<template>
  <div class="center-warp">
    <div class="inner d-flex-between">
        <div class="left-menu" v-loading="loading">
          <div class="reset-btn" :class="menuIndex == 0 ? 'on':''" @click="menuChange(0)">所有学员</div>
          <div class="reset-btn" :class="menuIndex == 1 ? 'on':''" @click="menuChange(1)">新增病例</div>
          <template v-if="member.member_type != 4">
            <div class="reset-btn" :class="menuIndex == 2 ? 'on':''" @click="menuChange(2)">我的学员</div>
          </template>
        </div>
        <div class="right-cont">
          <div class="filter-line">
            <div class="filter-input">
<!--              <input placeholder="医生姓名" type="text" v-model="searchOption.keyWords" @keydown.enter="initList(true)">-->
              <Input :placeholder="'医生姓名'" v-model="searchOption.keyWords" @enter="initList(true)"/>
              <img alt="" src="@/assets/img/base/search.png" @click="initList(true)">
            </div>
            <div style="position: relative">
              <div class="el-dropdown-link filter-drop" @click="openDrop">
                {{ citySearchVal.length ? '已筛选' : '筛选' }}<i class="iconfont icon-xialaanniu"></i>
              </div>
              <div class="filter-drop-cont" v-if="showDrop">
                  <div class="d-flex-between">
                    <div class="btn-cancel"  @click="showDrop = false">取消</div>
                    <div class="btn-ok" @click="initList(true)">完成</div>
                  </div>
                <div class="area-cont">
                    <div class="area-block area-all" :class="!cityVal.length ? 'on' : ''" @click="cityChoose(-1)">不限区域</div>
                    <div class="area-block" v-for="item in cityList" :class="cityVal.indexOf(item.province) != -1 ? 'on' : ''" @click="cityChoose(item.province)">{{ item.province }}</div>
                </div>
              </div>
            </div>
            <div class="filter-sort">
              <div class="filter-sort-item" :class="orderByIndex == index ? 'on' : ''" v-for="(item,index) in orderList" @click="orderByChange(index)">
                {{ item.name }}·<span @click.stop="orderSortChange(index)" class="hover-bg">{{ item.orderName[orderBySortIndex[index]] }}<i class="iconfont icon-qiehuan"></i></span></div>
            </div>
          </div>
          <div class="filter-cont" ref="listRef">
              <div class="doctor-list hover-shadow" v-for="item in doctorList" @click="goPage(item.id,item.real_name,item.organization)">
                <img v-if="item.head_pic" class="doctor-head" :src="item.head_pic" alt="">
                <div v-else class="doctor-head-default">
                  <img src="../../assets/img/base/default.png" alt="">
                </div>
                <div class="doctor-info">
                  <div class="doctor-word1">{{ item.real_name }}医生</div>
                  <div class="doctor-word2">{{ item.city }}·{{ item.province }}/{{ item.organization }}</div>
                </div>
                <img v-if="item.new_case > 0" class="right-tag" src="../../assets/img/base/newCaseTag.png" alt="">
                <div v-if="item.show_red_dot" class="doctor-dot"></div>
              </div>
              <div class="load-info" v-if="loadStatus != 'over'"><i class="el-icon-loading" v-if="loadStatus == 'load'"></i><span v-if="loadStatus == 'load'">加载中</span><span v-if="loadStatus == 'over'">已经全部加载完成</span></div>
              <Empty v-if="!doctorList.length && (!loadStatus || loadStatus == 'over')" :img-width="'200px'" :info="'暂无学员'" />
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import {GetAllowShowCity, GetDoctorList} from "@/http/api";

export default {
  name: "index",
  data() {
    return {
      menuIndex: 0,
      urlList:['/api/member/doctorListFull','/api/member/doctorListNewPatient','/api/member/doctorListMy'],
      showDrop:false,
      searchOption:{
        page: 1,
        pageSize: 15,
        orderBy: [],
        mentor_id: '',
        keyWords: "",
        province: ""
      },
      orderList:[
        {
          name:'最新消息',
          param_name:'im_chaosong_at',
          orderName: ["新-旧", "旧-新"],
          orderBy: ["desc", "asc"]
        },
        {
          name:'医生姓名',
          param_name:'real_name',
          orderName: ["A-Z", "Z-A"],
          orderBy: ["asc", "desc"]
        },
        {
          name:'区域',
          param_name:'province',
          orderName: ["A-Z", "Z-A"],
          orderBy: ["asc", "desc"]
        },
        {
          name:'新病例数',
          param_name:'new_case',
          orderName: ["多-少", "少-多"],
          orderBy: ["desc", "asc"]
        }
      ],
      orderByIndex: 0,
      orderBySortIndex: [0,0,0,0],
      loadStatus:'',
      doctorList:[],
      cityList:[],
      cityVal:[],
      citySearchVal:[],
      member:JSON.parse(localStorage.getItem('member')),
      loading:false
    }
  },
  mounted() {
    var _that = this
    this.$store.commit('breadChange',{name:'学员列表',isBack:false})
    this.initList(true)
    this.initCity()
    this.$nextTick(()=>{
      _that.$refs.listRef.addEventListener('scroll', (e)=>{
        var scrollTop = e.target.scrollTop
        var windowHeight = e.target.clientHeight
        var scrollHeight = e.target.scrollHeight
        if(scrollTop+windowHeight == scrollHeight){
          // 当前滚动条已经触底
          _that.initList()
        }
      });
    })
  },
  methods: {
    menuChange(i) {
      this.menuIndex = i
      this.initList(true)
    },
    initCity(){
      GetAllowShowCity().then(res=>{
        this.cityList = res.data
      })
    },
    goPage(id,name,organization){
      this.$router.push({
        name:'导师病历管理',
        query:{
          doctor_id:id,
          name:name,
          organization:organization
        }
      })
    },
    openDrop(){
      if(this.showDrop){
        this.showDrop = false
        return false
      }
      this.showDrop = true
      this.cityVal = []
      this.citySearchVal.forEach(item=> this.cityVal.push(item))
    },
    initList(isRefresh){
      this.citySearchVal = []
      this.cityVal.forEach(item=> this.citySearchVal.push(item))

      var _that = this
      this.showDrop = false
      if(isRefresh){
        this.searchOption.page = 1
        this.doctorList = []
      }else if(this.loadStatus == 'over'){
        return
      }
      this.loadStatus = 'load'
      this.loading = true
      this.searchOption.mentor_id = JSON.parse(localStorage.getItem('member')).id
      let orderBy = []
      orderBy.push(this.orderList[this.orderByIndex].param_name)
      orderBy.push(this.orderList[this.orderByIndex].orderBy[this.orderBySortIndex[this.orderByIndex]])
      this.searchOption.orderBy = orderBy
      this.searchOption.province = this.cityVal.join(',')
      GetDoctorList(this.urlList[this.menuIndex],this.searchOption).then(res=>{
        this.loading = false
          let currentData = res.data.data
        _that.doctorList = _that.doctorList.concat(currentData)
        if(res.data.current_page >= res.data.last_page)  {
          _that.loadStatus = 'over'
        }
        else {
          _that.loadStatus = ''
          _that.page += 1
        }
      })
    },
    orderByChange(i){
      this.orderByIndex = i
      this.initList(true)
    },
    orderSortChange(i){
      this.$set(this.orderBySortIndex,i,Math.abs(this.orderBySortIndex[i] - 1))
      if(i == this.orderByIndex) this.initList(true)
    },
    cityChoose(name){
      if(name == -1){
        this.cityVal = []
        return
      }
      if(this.cityVal.indexOf(name) == -1){
        this.cityVal.push(name)
      }else{
        this.cityVal.splice(this.cityVal.indexOf(name),1)
      }
    }
  }
}
</script>

<style scoped src="../../assets/css/doctor.css">
</style>
